import { i18n } from '@lingui/core'
import { Trans } from '@lingui/macro'
import { MenuItem, TextField } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'

export const FORM_ACTION_OPEN_FS_QUIZ = 'FORM_ACTION_OPEN_FS_QUIZ'

export const ACTION_BUTTON_ACTIONS = {
  [FORM_ACTION_OPEN_FS_QUIZ]: {
    label: i18n._('OPEN_FUNDING_STREAM')
  }
}

export const FormEditorActionButton: React.FC<{}> = ({
  depth,
  typeProps,
  injectable,
  ...props
}) => {
  const dispatch = useDispatch()
  const { variant, color, action, parameter } = typeProps

  return (
    <div>
      <TextField
        select
        fullWidth
        variant='outlined'
        value={variant ?? 'contained'}
        style={{ marginTop: 10 }}
        label={<Trans>VARIANT</Trans>}
        onChange={(e) => {
          const toSet = { ...typeProps }
          toSet.variant = e.target.value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      >
        <MenuItem value='outlined'>
          <Trans>
            OUTLINED
          </Trans>
        </MenuItem>
        <MenuItem value='contained'>
          <Trans>
            CONTAINED
          </Trans>
        </MenuItem>
        <MenuItem value='text'>
          <Trans>
            TEXT
          </Trans>
        </MenuItem>
      </TextField>

      <TextField
        select
        fullWidth
        variant='outlined'
        value={color ?? 'primary'}
        style={{ marginTop: 10 }}
        label={<Trans>COLOR</Trans>}
        onChange={(e) => {
          const toSet = { ...typeProps }
          toSet.color = e.target.value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      >
        <MenuItem value='primary'>
          <Trans>
            PRIMARY
          </Trans>
        </MenuItem>
        <MenuItem value='secondary'>
          <Trans>
            SECONDARY
          </Trans>
        </MenuItem>
      </TextField>

      <TextField
        select
        fullWidth
        variant='outlined'
        value={action ?? ''}
        style={{ marginTop: 10 }}
        label={<Trans>ACTION</Trans>}
        onChange={(e) => {
          const toSet = { ...typeProps }
          toSet.action = e.target.value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      >
        {Object.entries(ACTION_BUTTON_ACTIONS).map(([key, obj]) =>
          <MenuItem value={key} key={key}>
            {obj.label}
          </MenuItem>)}
      </TextField>

      <TextField
        fullWidth
        variant='outlined'
        value={parameter ?? ''}
        style={{ marginTop: 10 }}
        label={<Trans>PARAMETER</Trans>}
        onChange={(e) => {
          const toSet = { ...typeProps }
          toSet.parameter = e.target.value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      />
    </div>
  )
}
